import R from 'ramda'
import axios from '../axios'
import config from '../config'
import { maxPrice, maxArea, maxRooms, maxYield } from '../Utils/Constants'

export const addToFavorites = (userId, id, type) => {
  return axios.post(
    config.SERVER_URL +
      '/user/' +
      userId +
      '/' +
      type +
      '/' +
      id +
      '/add_preferred'
  )
}

export const removeFromFavorites = (userId, id, type) => {
  return axios.post(
    config.SERVER_URL +
      '/user/' +
      userId +
      '/' +
      type +
      '/' +
      id +
      '/remove_preferred'
  )
}

export const updateUserPicture = (userId, picture) => {
  return axios.post(config.SERVER_URL + '/user/' + userId + '/', {
    picture: picture
  })
}

export const addPreference = (userId, preference) => {
  const body = R.clone(preference)
  if (preference.city) {
    body.city = preference.city.id
  }
  if (preference.category) {
    body.category = preference.category.id
  }

  if (preference.maxYield === maxYield) {
    delete body.maxYield
  }

  if (preference.maxPrice === maxPrice) {
    delete body.maxPrice
  }

  if (preference.maxArea === maxArea) {
    delete body.maxArea
  }

  if (preference.maxNoRooms === maxRooms) {
    delete body.maxNoRooms
  }

  body.user = userId
  return axios.post(`${config.SERVER_URL}/preference/`, body)
}

export const removePreference = preferenceId => {
  return axios.delete(`${config.SERVER_URL}/preference/${preferenceId}`)
}

export const deleteUserPreference = (preferenceId, userId) => {
  return axios.delete(
    `${config.SERVER_URL}/preference/${preferenceId}?user=${userId}`
  )
}

export const updatePreference = preference => {
  return axios.put(
    `${config.SERVER_URL}/preference/${preference.id}`,
    preference
  )
}

export const fetchPreferences = (criteria = {}, params = {}) => {
  return axios.post(`${config.SERVER_URL}/preference/fetch`, {
    criteria,
    params
  })
}

export const sendNda = id => {
  return axios.post(`${config.SERVER_URL}/user/send_nda`, { id })
}



// WEBPACK FOOTER //
// ./src/sources/UserSource.js